module.exports = __webpack_public_path__ + "static/media/Vector_left.53a0136b.svg";